import { Component, Input } from '@angular/core';
import { compact } from '@imcc/utilities';
import { ButtonType } from '../button-type';
import { commonButtonClasses } from '../common-button-classes';
import { HtmlType } from '../html-type';

/**
 *
 * @property {HtmlType} htmlType   - Button, Submit or Reset.
 * @property {string} icon         - Path to icon.
 * @property {string} text         - The text on the button.
 * @property {boolean} disabled    - Disabling the button.
 * @property {boolean} loading     - Loading indicator.
 * @property {string} prefix       - Prefixing css classes.
 * @property {string} alignment    - How the button should align with other
 *                                   elements.
 *                                   - 'default': make no effort to align.
 *                                   - 'inline': align with text.
 *
 * @export
 * @class IconButtonComponent
 */
@Component({
  selector: 'app-fm-icon-button',
  templateUrl: './icon-button.component.html',
})
export class IconButtonComponent {
  @Input() htmlType: HtmlType = HtmlType.Button;

  @Input() icon: string;

  @Input() text: string | null = null;

  @Input() disabled = false;

  @Input() loading = false;

  @Input() prefix = '';

  @Input() additionalClasses: string[] = [];

  @Input() alignment: 'default' | 'inline' = 'default';

  type: ButtonType = ButtonType.Icon;

  get classNames(): string {
    return compact([
      ...commonButtonClasses(this.type, this.prefix, this.loading),
      ...this.additionalClasses,
      this.alignmentClass,
    ]).join(' ');
  }

  get alignmentClass(): string | undefined {
    if (this.alignment === 'inline') {
      return `${this.prefix}btn--icon-inline`;
    }

    return undefined;
  }

  propagateEvent(): void {}
}
